export const openExternalLink = ({
  url,
  target = "_blank",
  features,
}: {
  url: string;
  target?: string;
  features?: string;
}) => {
  window.open(url, target, features);
};
